import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable react/jsx-pascal-case */
import { Container, Link, Palette } from '@uswitch/ev-core/react';
import { useDataSelector, useMeta } from '@uswitch/ev-utils/context/selectors';
import dayjs from '@uswitch/ev-utils/date';
import sw from '@uswitch/ev-utils/switch';
import { Type } from '@uswitch/spark';
import { Themed } from 'theme-ui';
import ImgixImg from '../../elements/imgix-img/connected';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";

var TrustyleAuthor = function TrustyleAuthor(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      authorImage = _ref.authorImage,
      titleUrl = _ref.titleUrl,
      variant = _ref.variant,
      subtitleUrl = _ref.subtitleUrl,
      className = _ref.className;

  var getVariant = function getVariant(element) {
    return "elements.author.".concat(variant ? variant + '.' + element : element);
  };

  return _jsxs("div", {
    sx: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'row',
      variant: getVariant('base')
    },
    className: className,
    children: [authorImage ? _jsx(Link, {
      href: titleUrl,
      sx: {
        flexShrink: 0,
        height: [40, 64],
        width: [40, 64],
        marginRight: 'sm',
        variant: getVariant('imageLink')
      },
      children: _jsx(authorImage.type, _objectSpread(_objectSpread({}, authorImage.props), {}, {
        sx: {
          maxHeight: '100%',
          maxWidth: '100%',
          borderRadius: '50%',
          variant: getVariant('image')
        }
      }))
    }) : null, _jsxs("div", {
      children: [_jsx(Type.Body2, {
        sx: {
          marginTop: 0,
          paddingBottom: 0,
          marginBottom: [0, 'xxs'],
          variant: getVariant('title')
        },
        children: _jsx(Palette, {
          as: Themed.a,
          href: titleUrl,
          sx: {
            color: 'inherit',
            textDecoration: 'none',
            variant: getVariant('link')
          },
          px: {
            color: 'textColor'
          },
          children: title
        })
      }), subtitle && _jsx(Type.Body2, {
        sx: {
          display: 'block',
          marginY: 0,
          variant: getVariant('subtitle')
        },
        children: _jsx(Palette, {
          as: Themed.a,
          href: subtitleUrl,
          sx: {
            textDecoration: 'none',
            variant: getVariant('link')
          },
          px: {
            color: 'textColor'
          },
          children: subtitle
        })
      })]
    })]
  });
};

var AuthorWithOptionalEditor = function AuthorWithOptionalEditor(_ref2) {
  var author = _ref2.author,
      editor = _ref2.editor,
      verifier = _ref2.verifier,
      publishDate = _ref2.publishDate,
      _ref2$showWrittenBy = _ref2.showWrittenBy,
      showWrittenBy = _ref2$showWrittenBy === void 0 ? false : _ref2$showWrittenBy;

  var authorImage = _jsx(ImgixImg, {
    entity: (author === null || author === void 0 ? void 0 : author.image) || (author === null || author === void 0 ? void 0 : author.photo),
    width: 100,
    height: 100,
    imgixParams: {
      fit: 'crop',
      crop: 'faces'
    }
  });

  var writtenByTitle = "".concat(showWrittenBy ? 'Written by ' : '').concat(author === null || author === void 0 ? void 0 : author.name).concat(author !== null && author !== void 0 && author.role ? ", ".concat(author === null || author === void 0 ? void 0 : author.role) : "");
  var editedBySubtitle;
  var subtitleUrl = '';

  if (editor !== null && editor !== void 0 && editor.name) {
    editedBySubtitle = "Edited by ".concat(editor.name).concat(editor.role ? ", ".concat(editor.role) : '');
    subtitleUrl = editor === null || editor === void 0 ? void 0 : editor.url;
  } else if (verifier !== null && verifier !== void 0 && verifier.name) {
    editedBySubtitle = "Verified by ".concat(verifier.name).concat(verifier.role ? ", ".concat(verifier.role) : '');
    subtitleUrl = verifier === null || verifier === void 0 ? void 0 : verifier.url;
  }

  var fullSubtitle = publishDate ? [editedBySubtitle, dayjs(publishDate).format('LL')].filter(function (i) {
    return i;
  }).join(', ') : editedBySubtitle;
  return _jsx(TrustyleAuthor, {
    authorImage: authorImage,
    title: writtenByTitle,
    titleUrl: author === null || author === void 0 ? void 0 : author.url,
    subtitle: fullSubtitle,
    subtitleUrl: subtitleUrl,
    variant: author === null || author === void 0 ? void 0 : author.variant
  });
};

var BroadbandDealsAuthor = function BroadbandDealsAuthor(_ref3) {
  var author = _ref3.author;

  var authorImage = _jsx(ImgixImg, {
    entity: author === null || author === void 0 ? void 0 : author.image
  });

  return _jsx(TrustyleAuthor, {
    authorImage: authorImage,
    title: author === null || author === void 0 ? void 0 : author.name,
    subtitle: author === null || author === void 0 ? void 0 : author.role,
    titleUrl: author === null || author === void 0 ? void 0 : author.url,
    subtitleUrl: author === null || author === void 0 ? void 0 : author.url,
    variant: author === null || author === void 0 ? void 0 : author.variant
  });
};

var BankrateAuthor = function BankrateAuthor(_ref4) {
  var author = _ref4.author,
      publishedAt = _ref4.publishedAt,
      updatedAt = _ref4.updatedAt;

  var authorImage = _jsx(ImgixImg, {
    entity: author === null || author === void 0 ? void 0 : author.image
  });

  var dateTimeFormat = useMeta(['authorConfig', 'dateTimeFormat'], 'ddd DD MMM YYYY hh.mm');
  var singleDate = useMeta(['authorConfig', 'singleDate']);
  var publishedAtFormat = 'ddd DD MMM YYYY';
  var updatedAtFormat = dateTimeFormat;
  var hidePublishedAt = Boolean(updatedAt && singleDate);
  return _jsxs(Container, {
    sx: {
      variant: 'elements.author.outerContainer'
    },
    className: "authorContainer",
    children: [publishedAt && !hidePublishedAt ? _jsx(Themed.p, {
      sx: {
        variant: 'elements.author.publishedAt'
      },
      children: "Published ".concat(dayjs(publishedAt).format(publishedAtFormat))
    }) : null, _jsx(Themed.p, {
      sx: {
        variant: 'elements.author.updatedAt'
      },
      children: updatedAt ? "Updated on ".concat(dayjs(updatedAt).format(updatedAtFormat), " GMT") : null
    }), _jsx(TrustyleAuthor, {
      authorImage: authorImage,
      title: author === null || author === void 0 ? void 0 : author.name,
      subtitle: author === null || author === void 0 ? void 0 : author.role,
      titleUrl: author === null || author === void 0 ? void 0 : author.url,
      subtitleUrl: author === null || author === void 0 ? void 0 : author.url,
      variant: (author === null || author === void 0 ? void 0 : author.variant) || 'articleDates'
    })]
  });
};

var SOEAuthor = function SOEAuthor(_ref5) {
  var author = _ref5.author,
      publishedAt = _ref5.publishedAt,
      updatedAt = _ref5.updatedAt;

  var authorImage = _jsx(ImgixImg, {
    entity: (author === null || author === void 0 ? void 0 : author.image) || (author === null || author === void 0 ? void 0 : author.photo)
  });

  var dateTimeFormat = useMeta(['authorConfig', 'dateTimeFormat'], 'ddd DD MMM YYYY hh.mm');
  var singleDate = useMeta(['authorConfig', 'singleDate']);

  var formatDate = function formatDate(date) {
    return dayjs(date).format(dateTimeFormat);
  };

  var hidePublishedAt = Boolean(updatedAt && singleDate);
  return _jsxs(Container, {
    sx: {
      variant: 'elements.author.outerContainer'
    },
    children: [_jsx(Themed.p, {
      sx: {
        variant: 'elements.author.text'
      },
      children: "Written by"
    }), _jsx(TrustyleAuthor, {
      authorImage: authorImage,
      title: author === null || author === void 0 ? void 0 : author.name,
      subtitle: author === null || author === void 0 ? void 0 : author.role,
      titleUrl: author === null || author === void 0 ? void 0 : author.url,
      subtitleUrl: author === null || author === void 0 ? void 0 : author.url,
      variant: author === null || author === void 0 ? void 0 : author.variant
    }), updatedAt ? _jsx(Themed.p, {
      sx: {
        variant: 'elements.author.text',
        mb: 0
      },
      children: "Updated on ".concat(formatDate(updatedAt), " GMT")
    }) : null, publishedAt && !hidePublishedAt ? _jsx(Themed.p, {
      sx: {
        variant: 'elements.author.text'
      },
      children: "Published on ".concat(formatDate(publishedAt), " GMT")
    }) : null]
  });
};

var Author = function Author(props) {
  var _useDataSelector = useDataSelector(['dates']),
      publishDate = _useDataSelector.publishDate,
      updatedDate = _useDataSelector.updatedDate;

  var brandTitle = useMeta(['title']);
  return sw({
    'saveonenergy.com': function saveonenergyCom(props) {
      return _jsx(SOEAuthor, _objectSpread(_objectSpread({}, props), {}, {
        publishedAt: publishDate,
        updatedAt: updatedDate
      }));
    },
    'Broadband Deals': function BroadbandDeals(props) {
      return _jsx(BroadbandDealsAuthor, _objectSpread(_objectSpread({}, props), {}, {
        publishedAt: publishDate,
        updatedAt: updatedDate
      }));
    },
    'Bankrate UK': function BankrateUK(props) {
      return _jsx(BankrateAuthor, _objectSpread(_objectSpread({}, props), {}, {
        publishedAt: publishDate,
        updatedAt: updatedDate
      }));
    },
    default: function _default(props) {
      return _jsx(AuthorWithOptionalEditor, _objectSpread(_objectSpread({}, props), {}, {
        publishedAt: publishDate,
        updatedAt: updatedDate
      }));
    }
  })(brandTitle, props);
};

export default Author;
//# sourceMappingURL=trustyle-author.js.map